

























import { Component, Prop, Vue } from 'vue-property-decorator';
import { mdbBtn, mdbCard, mdbCardBody, mdbCardTitle, mdbTooltip } from '@folky-tools/mdbvue';
import { BusinessFrontPageClaims } from '@/models/businesses/business-front-page-claims';

@Component({
    components: {
        mdbBtn,
        mdbCard,
        mdbCardBody,
        mdbCardTitle,
        mdbTooltip
    }
})
export default class FrontPageTitles extends Vue {
    @Prop(Boolean) private canWrite!: boolean;
    @Prop(BusinessFrontPageClaims) private titles!: BusinessFrontPageClaims;
    @Prop(Boolean) private pageContentLoaded!: boolean;

    private editFrontPageTitles(): void {
        this.$emit('clicked-edit-front-page-titles');
    }
}
